import { fromPromise } from 'xstate';

import type { AddToBagInput } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const addToBag = fromPromise<void, AddToBagInput>(async () => {
  throw new Error('`addToBag` actor is not provided.');
});
